import React from 'react';
import { Form, Button } from 'react-bootstrap';

const MagicLinkForm = ({ 
    email, 
    setEmail, 
    onSubmit, 
    disabled = false, 
    buttonText,
    placeholder = "you@example.com",
    className = "magic-link-form"
}) => {
    // Validate required props
    if (!buttonText) {
        console.error('MagicLinkForm: buttonText prop is required');
        return null;
    }

    return (
        <Form onSubmit={onSubmit} className={className}>
            <Form.Group className="mb-2">
                <Form.Control
                    type="email"
                    placeholder={placeholder}
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="magic-link-email-input"
                    required
                    disabled={false}
                />
            </Form.Group>
            
            <Button 
                type="submit"
                className="magic-link-submit-btn btn-primary-gradient"
                disabled={false}
            >
                {buttonText}
            </Button>
        </Form>
    );
};

export default MagicLinkForm;
